export default "__VITE_ASSET__Da2I$rR9__"